<script>
    export let id;
</script>

<section {id} class="dashboard-section">
    <slot></slot>
</section>

<style>
    .dashboard-section {
        margin-bottom: 75px;
    }
</style>